import { axios, AxiosResponse } from '~/modules'
import { IBirthReport, IGetBirthReportParams } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchBirthReport = async (params: IGetBirthReportParams): Promise<IBirthReport> => {
  const { pathParams } = params

  const response = await axios.get(`${hstoryAPI}/patients/${pathParams.patientId}/birth-report`)
  const { data }: AxiosResponse<IBirthReport> = response
  return data
}
